import { h, Fragment } from 'preact';

import Image from '../utils/image';
import MobileMenuList from './mobile-menu-list';

const MobileSubMenuItems = ({
  megaMenus,
  megaMenusBanners,
  activeSubMenuLink = false,
}) => (
    <>
      <div className="flex flex-col items-start justify-start w-full">
        {megaMenus?.length > 0 &&
          megaMenus?.map((menuList) => {
            const isFeatured = menuList.handle === 'Featured';
            if (isFeatured) {
              return (
                <div key={menuList.handle} className="p-5 w-full" style={{order: menuList.index+30}}>
                  <p className="font-14-bold text-black mb-5">
                    {menuList.handle}
                  </p>
                  <ul>
                    {menuList.links.length > 0 &&
                      menuList.links.map((link) => (
                        <li key={link.label} className="mb-5">
                          <a href={link.url} className="font-14 text-charcoal">
                            {link.label}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              );
            }
            return <MobileMenuList menuList={menuList} key={menuList.handle} />;
          })}
        {activeSubMenuLink && activeSubMenuLink.url !== '#' && (
          <div className="p-5 order-[20] w-full">
            <div className="bg-cream-grey text-center w-full pt-[18px] pb-5">
              <a
                href={activeSubMenuLink.url}
                className="text-black cta-small uppercase underline"
              >
                {window.TMW?.Strings?.header?.shopAll} {activeSubMenuLink.title}
              </a>
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col items-start justify-start px-5 pt-5">
        {megaMenusBanners?.length > 0 &&
          megaMenusBanners?.map((banner) => (
            <div key={banner.title} className="w-full pb-10 text-center">
              {banner.url && (
                <a
                  href={banner.url}
                  className="mb-2.5 block link-unstyled"
                  target={banner.new_tab ? '_blank' : ''}
                  rel="noreferrer"
                >
                  <Image
                    src={banner.image}
                    classes="w-full"
                    srcWidths={{
                      sm: 640,
                      md: 768,
                      lg: 1024,
                      xl: 1280,
                      '2xl': 1536,
                    }}
                  />
                </a>
              )}
              {!banner.url && (
                <Image
                  src={banner.image}
                  classes="mb-2.5 w-full"
                  srcWidths={{
                    sm: 640,
                    md: 768,
                    lg: 1024,
                    xl: 1280,
                    '2xl': 1536,
                  }}
                />
              )}
              {banner.title && banner.url && (
                <a
                  href={banner.url}
                  target={banner.new_tab ? '_blank' : ''}
                  className="font-13 text-black underline block w-fit mx-auto"
                  rel="noreferrer"
                >
                  {banner.title}
                </a>
              )}
              {banner.title && !banner.url && (
                <p className="font-13 text-black block w-fit mx-auto">
                  {banner.title}
                </p>
              )}
            </div>
          ))}
      </div>
    </>
  );

export default MobileSubMenuItems;
